import { Company } from '../types/companies-grid-company';
import { MspInProductTrialId } from "../../../company/common/mspInProductTrialsTab/types/msp-in-product-trials-types";

export enum CompaniesGridEvents {
  OnCompanyNameClick = 'companiesGridCompanyNameClick',
  OnCompanyNameUpdates = 'companiesGridCompanyNameClick',

  OnAddCompany = 'companiesGridAddCompany',
  OnDeleteCompany = 'companiesGridDeleteCompany',

  OnActivateCompany = 'companiesGridActivateCompany',
  OnSuspendCompany = 'companiesGridSuspendCompany',

  OnModifyMspInProductTrialsRights = 'companiesGridModifyMspInProductTrialsRights',
  OnModifyMspInProductTrialsVisibility = 'companiesGridModifyMspInProductTrialsVisibility',
}

export class OnCompanyNameClick extends CustomEvent<{ companyId: string; companyName: string }> {
  constructor(companyId: string, companyName: string) {
    super(CompaniesGridEvents.OnCompanyNameClick, {
      detail: {
        companyId,
        companyName,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnAddCompany extends CustomEvent<{}> {
  constructor() {
    super(CompaniesGridEvents.OnAddCompany, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnDeleteCompany extends CustomEvent<{ companyIds: Array<{ _id: string }> }> {
  constructor(companyIds: Array<{ _id: string }>) {
    super(CompaniesGridEvents.OnDeleteCompany, {
      detail: {
        companyIds,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnActivateCompany extends CustomEvent<{ companies: Company[] }> {
  constructor(companies: Company[]) {
    super(CompaniesGridEvents.OnActivateCompany, {
      detail: {
        companies,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnSuspendCompany extends CustomEvent<{ companies: Company[] }> {
  constructor(companies: Company[]) {
    super(CompaniesGridEvents.OnSuspendCompany, {
      detail: {
        companies,
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnModifyMspInProductTrialsRights extends CustomEvent<{ companies: Company[], status: boolean, productTrialId: MspInProductTrialId }> {
  constructor(companies: Company[], status: boolean, productTrialId: MspInProductTrialId) {
    super(CompaniesGridEvents.OnModifyMspInProductTrialsRights, {
      detail: {
        companies,
        status,
        productTrialId
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnModifyMspInProductTrialsVisibility extends CustomEvent<{ companies: Company[], status: boolean, productTrialId: MspInProductTrialId }> {
  constructor(companies: Company[], status: boolean, productTrialId: MspInProductTrialId) {
    super(CompaniesGridEvents.OnModifyMspInProductTrialsVisibility, {
      detail: {
        companies,
        status,
        productTrialId
      },
      bubbles: true,
      composed: true,
    });
  }
}

export class OnCompanyNameUpdates extends CustomEvent<{ companyName: string }> {
  constructor(companyName: string) {
    super(CompaniesGridEvents.OnCompanyNameUpdates, {
      detail: {
        companyName,
      },
      bubbles: true,
      composed: true,
    });
  }
}
